<h1 translate>TIRE_POLICY_LIST</h1>
<div class="text-right mb-3">
  <button class="btn btn-primary mr-2" type="button" (click)="openTirePolicyImportModal()">
    <span translate>IMPORT</span>(XLSX)
  </button>
  <button class="btn btn-primary " type="button" (click)="downloadTirePolicy()">
    <span translate>EXPORT</span>(XLSX)
  </button>
</div>
<lib-filter-list [configService]="configService"></lib-filter-list>
